import { createCookie, getFromQuery } from './util';

function createRegCookie(cookieValue) {
  const cookieName = 'register';
  document.cookie = `${cookieName}=${cookieValue};path=/;secure=yes`;
}

export function loadCookies() {
  createRegCookie('no');
  createCookie('currenturl', document.URL, 1);

  const shouldShowLogout = getFromQuery('showLogout');
  if (shouldShowLogout) {
    createCookie('showLogout', shouldShowLogout, 1);
  }

  const returnToValue = getFromQuery('returnTo');
  if (returnToValue) {
    createCookie('returnTo', returnToValue, 1);
  }
}

export function termsOfUseClick() {
  window.sessionStorage.setItem('termsOfUseClicked', true);
}

export function dataProtectionClick() {
  window.sessionStorage.setItem('dataProtectionClicked', true);
  setAcceptButton();
}

export function setAcceptButton() {
  const dataProtectionClicked = window.sessionStorage.getItem('dataProtectionClicked');
  const regionValue = document.getElementById('region').value;

  if ((regionValue !== 'ROI' && dataProtectionClicked) || regionValue === 'ROI') {
    document.getElementById('aibBtnAcceptTc').disabled = false;
    document.getElementById('aibBtnAcceptTc').classList.remove('disabled');
  } else {
    document.getElementById('aibBtnAcceptTc').disabled = true;
    document.getElementById('aibBtnAcceptTc').classList.add('disabled');
  }
}

// Setup the aib namespace
const localWindow = window || {};
localWindow.aib = localWindow.aib || {};
const { aib } = localWindow;
aib.identifier = {
  ...aib.identifier,
  loadCookies,
  createRegCookie,
  termsOfUseClick,
  dataProtectionClick,
  setAcceptButton,
};
